import { render, staticRenderFns } from "./LegoCheck.vue?vue&type=template&id=7beab07a&scoped=true"
import script from "./LegoCheck.vue?vue&type=script&lang=js"
export * from "./LegoCheck.vue?vue&type=script&lang=js"
import style0 from "./LegoCheck.vue?vue&type=style&index=0&id=7beab07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beab07a",
  null
  
)

export default component.exports